import {URL} from './urls';

export default function getTeleconnectCompanies(accesToken) {
  const apiURL = URL + `/teleconnect_companies`

  return fetch(apiURL, {
    headers: {
      'Authorization': `Bearer ${accesToken}`
    }
  })
    .then(res => res.json())
    .then(response => {
      const tempArray = [];
      if (response) {
        if (response.length) {
          response.forEach((element) => {
            tempArray.push({
              label: `${element.name}`,
              value: element.id,
            });
          });
        } else {
          tempArray.push({
            label: `${response.name}`,
            value: response.id,
          });
        }
      }
      return tempArray
    })
}